
import produce from 'immer';

import {
    IInitialState,
} from './interface';

import {
    HAND_OVER_TO_AGENT,
    REFRESH_WEBCHAT,
    REFRESH_WEBCHAT_FAILED,
    REFRESH_WEBCHAT_SUCCESS,
} from './constants';

/**
 * initialState
 */
export const initialState: IInitialState = {
    agent: false,
    loading: false,
    error: false,
    errorCode: false,
    response: false,
};

/**
 * appReducer
 * @param state
 * @param action
 */
const refreshWebchatReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case REFRESH_WEBCHAT:
                draft.loading = true;
                draft.error = false;
                draft.errorCode = false;
                break;
            case REFRESH_WEBCHAT_SUCCESS:
                draft.loading = false;
                draft.response = action.response;
                break;
            case REFRESH_WEBCHAT_FAILED:
                draft.loading = false;
                draft.error = action.error;
                draft.errorCode = action.errorCode;
                break;
            case HAND_OVER_TO_AGENT:
                draft.agent = true;
                break;
        }
    });

export default refreshWebchatReducer;
